<template>
	<div class="screensaver-content">
		<!-- Animated welcome message -->
		<div class="screensaver-ticker">
			<div class="ticker-content">
				<span class="ticker-item">{{ welcomeMessage }}</span>
				<span class="ticker-item">{{ openingHours }}</span>
				<span class="ticker-item">{{ welcomeMessage }}</span>
			</div>
		</div>
		
		<!-- Building logo in center -->
		<div class="screensaver-logo">
			<WFBuildingLogo />
		</div>
		
		<!-- Touch to start prompt -->
		<div class="screensaver-prompt">
			<p data-translation-element="touch-to-start">{{ touchPrompt }}</p>
		</div>
	</div>
</template>

<script>
import { WFBuildingLogo } from '@3dwayfinder/wayfinder-vue-components'

export default {
	name: 'Screensaver',
	components: {
		WFBuildingLogo
	},
	data() {
		return {
			welcomeMessage: 'Tere tulemast Kaubamajakasse!',
			openingHours: 'E-L 10-20 • P 10-18',
			touchPrompt: 'Puudutage ekraani alustamiseks'
		}
	},
	mounted() {
		// Update messages based on Wayfinder language
		if (this.$wayfinder) {
			this.updateMessages();
			this.$wayfinder.events.listen('language-change', () => {
				this.updateMessages();
			});
		}
	},
	methods: {
		updateMessages() {
			const lang = this.$wayfinder ? this.$wayfinder.getLanguage() : 'et';
			
			// Translate messages based on language
			const messages = {
				'et': {
					welcome: 'Tere tulemast Kaubamajakasse!',
					hours: 'E-L 10-20 • P 10-18',
					touch: 'Puudutage ekraani alustamiseks'
				},
				'en': {
					welcome: 'Welcome to Kaubamajak!',
					hours: 'Mon-Sat 10-20 • Sun 10-18',
					touch: 'Touch screen to start'
				},
				'fi': {
					welcome: 'Tervetuloa Kaubamajakaan!',
					hours: 'Ma-La 10-20 • Su 10-18',
					touch: 'Aloita koskettamalla näyttöä'
				},
				'ru': {
					welcome: 'Добро пожаловать в Kaubamajak!',
					hours: 'Пн-Сб 10-20 • Вс 10-18',
					touch: 'Коснитесь экрана, чтобы начать'
				},
				'lv': {
					welcome: 'Laipni lūdzam Kaubamajak!',
					hours: 'P-S 10-20 • Sv 10-18',
					touch: 'Pieskarieties ekrānam, lai sāktu'
				}
			};
			
			const msg = messages[lang] || messages['et'];
			this.welcomeMessage = msg.welcome;
			this.openingHours = msg.hours;
			this.touchPrompt = msg.touch;
		}
	}
}
</script>

<style scoped lang="less">
.screensaver-content {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	background: linear-gradient(135deg, #f5f5f5 0%, #ffffff 100%);
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 9999;
	overflow: hidden;
}

/* Animated ticker at top */
.screensaver-ticker {
	width: 100%;
	height: 12rem;
	background-color: #da020e;
	overflow: hidden;
	display: flex;
	align-items: center;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.ticker-content {
	display: flex;
	white-space: nowrap;
	animation: scroll-left 30s linear infinite;
	padding-left: 100%;
}

.ticker-item {
	font-size: 6rem;
	font-weight: 700;
	color: white;
	padding: 0 10rem;
	font-family: 'PF Centro Sans Pro Bold', sans-serif;
}

@keyframes scroll-left {
	0% {
		transform: translateX(0);
	}
	100% {
		transform: translateX(-50%);
	}
}

/* Building logo in center */
.screensaver-logo {
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	padding: 4rem;
	animation: pulse 3s ease-in-out infinite;
}

@keyframes pulse {
	0%, 100% {
		transform: scale(1);
		opacity: 1;
	}
	50% {
		transform: scale(1.05);
		opacity: 0.95;
	}
}

/* Touch to start prompt at bottom */
.screensaver-prompt {
	width: 100%;
	padding: 3rem;
	text-align: center;
	background-color: rgba(255, 255, 255, 0.9);
	box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.1);
}

.screensaver-prompt p {
	font-size: 3rem;
	font-weight: 600;
	color: #333;
	margin: 0;
	animation: blink 2s ease-in-out infinite;
}

@keyframes blink {
	0%, 100% {
		opacity: 1;
	}
	50% {
		opacity: 0.5;
	}
}

/* Mobile adjustments */
@media (max-width: 767px) {
	.screensaver-ticker {
		height: 8rem;
	}
	
	.ticker-item {
		font-size: 3.5rem;
		padding: 0 5rem;
	}
	
	.screensaver-prompt p {
		font-size: 2rem;
	}
}

/* Portrait/Kiosk adjustments */
@media (min-width: 768px) and (max-width: 2200px) {
	.screensaver-ticker {
		height: 10rem;
	}
	
	.ticker-item {
		font-size: 5rem;
		padding: 0 8rem;
	}
	
	.screensaver-prompt p {
		font-size: 2.5rem;
	}
}
</style>